/* QSPEC Calm — highlights carousel: scroll-snap track, numbered chapters, waveform play/pause */
(function () {
  'use strict';
  function init(root) {
    var track = root.querySelector('[data-hlc-track]');
    var cards = track ? Array.prototype.slice.call(track.children) : [];
    var dotsWrap = root.querySelector('[data-hlc-dots]');
    var pause = root.querySelector('[data-hlc-pause]');
    if (!track || cards.length < 2) return;
    var mql = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var reduced = !!(mql && mql.matches);
    var INTERVAL = 6000;
    var idx = 0, timer = null, settle = null, io = null, destroyed = false;
    var playing = !reduced;
    root.style.setProperty('--hlc-dur', INTERVAL + 'ms');

    var dots = cards.map(function (c, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'calm-hlc__dot';
      b.textContent = ('0' + (i + 1)).slice(-2);
      b.setAttribute('aria-label', 'ハイライト ' + (i + 1) + ' / ' + cards.length);
      b.addEventListener('click', function () { go(i, true); });
      if (dotsWrap) dotsWrap.appendChild(b);
      return b;
    });

    function setActive(i) {
      idx = i;
      dots.forEach(function (d, k) {
        d.classList.remove('is-active');
        if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
      void dots[i].offsetWidth; // restart the underline transition
      dots[i].classList.add('is-active');
    }
    function targetLeft(i) {
      var c = cards[i], tr = track.getBoundingClientRect(), cr = c.getBoundingClientRect();
      return track.scrollLeft + (cr.left - tr.left) - (tr.width - cr.width) / 2;
    }
    function go(i, user) {
      i = (i + cards.length) % cards.length;
      track.scrollTo({ left: targetLeft(i), behavior: reduced ? 'auto' : 'smooth' });
      setActive(i);
      if (user) { manual(); }
    }
    function nearest() {
      var tr = track.getBoundingClientRect(), center = tr.left + tr.width / 2, best = 0, bd = Infinity;
      cards.forEach(function (c, i) {
        var r = c.getBoundingClientRect(), d = Math.abs(r.left + r.width / 2 - center);
        if (d < bd) { bd = d; best = i; }
      });
      return best;
    }
    // any scroll of the track that we did not initiate counts as taking over
    var programmatic = false;
    function onScroll() {
      if (settle) clearTimeout(settle);
      settle = setTimeout(function () {
        var n = nearest();
        if (n !== idx) { setActive(n); if (!programmatic) manual(); }
        programmatic = false;
      }, 90);
    }
    track.addEventListener('scroll', onScroll, { passive: true });

    function tick() { programmatic = true; go(idx + 1, false); }
    function start() { if (!playing || timer || destroyed || root.classList.contains('is-manual')) return; setActive(idx); timer = setInterval(tick, INTERVAL); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function manual() { stop(); root.classList.add('is-manual'); } // user took over: no autoplay until they press play

    function syncPause() {
      if (!pause) return;
      pause.setAttribute('aria-pressed', playing ? 'false' : 'true');
      pause.setAttribute('aria-label', playing ? '自動再生を停止' : '自動再生を開始');
      root.classList.toggle('is-paused', !playing);
    }
    function onPause() {
      playing = !playing;
      syncPause();
      if (playing) { root.classList.remove('is-manual'); start(); } else stop();
    }
    if (pause) { syncPause(); pause.addEventListener('click', onPause); }

    function onKey(e) {
      if (e.key === 'ArrowLeft') { go(idx - 1, true); e.preventDefault(); }
      else if (e.key === 'ArrowRight') { go(idx + 1, true); e.preventDefault(); }
      else if (e.key === 'Home') { go(0, true); e.preventDefault(); }
      else if (e.key === 'End') { go(cards.length - 1, true); e.preventDefault(); }
    }
    track.setAttribute('tabindex', '0');
    track.addEventListener('keydown', onKey);

    function onMotionChange(e) { reduced = e.matches; if (reduced && playing) { playing = false; syncPause(); stop(); } }
    if (mql && mql.addEventListener) mql.addEventListener('change', onMotionChange);

    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (es) {
        if (es[0].isIntersecting) { if (!timer) start(); } else stop();
      }, { threshold: 0.4 });
      io.observe(root);
    } else start();

    setActive(0);
    if (!playing) root.classList.add('is-paused');

    root._calmHlc = { destroy: function () {
      if (destroyed) return;
      destroyed = true;
      stop();
      if (settle) clearTimeout(settle);
      if (io) { io.disconnect(); io = null; }
      track.removeEventListener('scroll', onScroll);
      track.removeEventListener('keydown', onKey);
      if (pause) pause.removeEventListener('click', onPause);
      if (mql && mql.removeEventListener) mql.removeEventListener('change', onMotionChange);
      dots.forEach(function (d) { if (d.parentNode) d.parentNode.removeChild(d); });
      root._init = false; delete root._calmHlc;
    } };
  }
  function boot() { document.querySelectorAll('[data-calm-hlc]').forEach(function (el) { if (!el._init) { el._init = true; init(el); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  if (!window.__calmHlcBound) {
    window.__calmHlcBound = true;
    document.addEventListener('shopify:section:load', boot);
    document.addEventListener('shopify:section:unload', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('[data-calm-hlc]') && t._calmHlc) t._calmHlc.destroy();
      if (t && t.querySelectorAll) t.querySelectorAll('[data-calm-hlc]').forEach(function (el) { if (el._calmHlc) el._calmHlc.destroy(); });
    });
  }
})();
